import React, { FC } from 'react';
import Form from 'components/Form';

import { HarpicPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Harpic: FC<HarpicPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Harpic;
